<div
  class="cmp-dialog"
  [class.cmp-dialog--leading]="variant() === 'modal-leading-icon'"
  [class.cmp-dialog--centered]="variant() === 'modal-centered-icon'"
  [class.cmp-dialog--alert]="variant() === 'alert'"
  [style.--cmp-dialog-width]="width() || null"
>
  @if (variant() === 'modal-leading-icon') {
    <header class="cmp-dialog__header">
      <div class="cmp-dialog__heading">
        @if (icon()) {
          <span class="cmp-dialog__lead-icon" aria-hidden="true" [innerHTML]="iconMarkup()"></span>
        }
        @if (title()) {
          <h2 class="cmp-dialog__title" [id]="titleId() || null">{{ title() }}</h2>
        }
      </div>
      @if (dismissible()) {
        <button type="button" class="cmp-dialog__close" [attr.aria-label]="closeLabel()" (click)="closeClick.emit()">
          <span class="cmp-dialog__close-icon" aria-hidden="true" [innerHTML]="closeMarkup()"></span>
        </button>
      }
    </header>
  } @else if (dismissible()) {
    <button
      type="button"
      class="cmp-dialog__close cmp-dialog__close--floating"
      [attr.aria-label]="closeLabel()"
      (click)="closeClick.emit()"
    >
      <span class="cmp-dialog__close-icon" aria-hidden="true" [innerHTML]="closeMarkup()"></span>
    </button>
  }

  <div class="cmp-dialog__body">
    @if (variant() === 'modal-centered-icon' && icon()) {
      <span class="cmp-dialog__badge" aria-hidden="true">
        <span class="cmp-dialog__badge-inner" [innerHTML]="centeredIconMarkup()"></span>
      </span>
    }
    @if (variant() !== 'modal-leading-icon' && (title() || description())) {
      <div class="cmp-dialog__text">
        @if (title()) {
          <h2 class="cmp-dialog__title" [id]="titleId() || null">{{ title() }}</h2>
        }
        @if (description()) {
          <p class="cmp-dialog__desc" [id]="descId() || null">{{ description() }}</p>
        }
      </div>
    }
    <ng-content />
  </div>

  @if (showActions()) {
    <footer class="cmp-dialog__actions">
      <ng-content select="[cmpDialogActions]" />
    </footer>
  }
</div>
